import { useState } from 'react'
import RoutesMap from 'route_control/RouteControl'
import { Form, InputGroup, Button, Card } from 'react-bootstrap'
import { Input } from 'antd'
import { useFormik } from 'formik'
import { KeyRound, UserRound, Eye, EyeOff } from 'lucide-react'
import { toast } from 'react-toastify'
import logo from 'assets/images/express-logo.png'
import { LoginSchema } from './ValidationSchema'
import { ButtonLoader } from 'components/loader'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { signIn, verifyOtp } from '../../../redux/slices/assets'
import { SessionManager } from 'utils'

export default function UserLoginForm(props) {

  const { setTogggle } = props

  const [spinner, setSpinner] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showOtp, setShowOtp] = useState(false)
  const [otp, setOtp] = useState('')
  const [tempUser, setTempUser] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const initialValues = {
    phone: '',
    password: '',
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: initialValues,
    validationSchema: LoginSchema,

    onSubmit: (values, action) => {
      // console.log(values)
      setSpinner(true)
      dispatch(signIn(values)).then((res) => signIn_user(res.payload, action))
    },
  })

  const signIn_user = (res, action) => {

    if (res?.status === 200) {
      if (res?.data?.data?.userResponse?.user_mfa) {
        setTempUser(res?.data?.data?.userResponse)
        setShowOtp(true)
        setSpinner(false)
        toast.success(res?.data?.message, { position: "bottom-right" })
      } else {
        SessionManager.setCookie('user', res?.data?.data?.user_data && JSON.stringify(res?.data?.data?.user_data), 3)
        navigate(RoutesMap.ROLE_LOGIN.path)
        toast.success("SignIn Successfully!!..", { position: "bottom-right" })
      }

    } else if (res?.status === 400) {
      setSpinner(false)
      toast.error(res?.data?.message, { position: "bottom-right" })
    } else if (res?.status === 403) {
      setSpinner(false)
      const blocked = res?.data?.data?.ip_blocked || res?.data?.data?.code === 'IP_ACCESS_BLOCKED'
      toast.error(
        res?.data?.message || (blocked ? 'Access denied. Your IP address is blocked.' : 'Access denied.'),
        { position: "bottom-right" },
      )
    } else if (res?.status === 500) {
      setSpinner(false)
      toast.error("Server error!!..", { position: "bottom-right" })
    } else {
      setSpinner(false)
      toast.error("Something went wrong!!..", { position: "bottom-right" })
    }
  }

  const handleVerifyOtp = () => {
    setSpinner(true)
    dispatch(verifyOtp({ user_id: tempUser?.user_id, user_name: tempUser?.user_name, otp })).then((res) => {
      setSpinner(false)
      if (res?.payload?.status === 200) {
        const data = res?.payload?.data?.data?.user_data
        SessionManager.setCookie('user', data && JSON.stringify(data), 3)
        navigate(RoutesMap.ROLE_LOGIN.path)
        toast.success("SignIn Successfully!!..", { position: "bottom-right" })
      } else {
        toast.error(res?.payload?.data?.message, { position: "bottom-right" })
      }
    })
  }

  return (
    <Card className="h-100 border-0 shadow" style={{ borderRadius: '16px', backgroundColor: '#ffffff', overflow: 'hidden' }}>
      <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100 d-flex flex-column'>

        <div className="text-end px-4 pt-3 pb-2">
          <u className='fw-medium text-muted' style={{ cursor: 'pointer', fontSize: '13px', textDecorationColor: '#006972' }} onClick={() => setTogggle(true)}>Forget Password?</u>
        </div>

        <Card.Body className='px-4 px-sm-5 d-flex flex-column justify-content-center'>
          <div className='text-center mb-2'>
            <img src={logo} alt="logo" className='img-fluid mb-2' style={{ height: '60px', objectFit: 'contain' }} />
            <h4 className='fw-bold mb-1' style={{ color: '#001529' }}>Sign In</h4>
            <p className="text-muted" style={{ fontSize: '14px' }}>Welcome back! Please enter your details.</p>
          </div>

          <div className='mb-1'>
            <Form.Label className='fw-semibold mb-1 text-dark' style={{ fontSize: '13px' }}>Username</Form.Label>
            <InputGroup
              className="rounded-3 shadow-sm"
              style={{ border: '1px solid #e1e5eb', overflow: 'hidden', backgroundColor: '#f9fafb' }}
            >
              <InputGroup.Text id="phone" className="bg-transparent border-0 text-muted px-3">
                <UserRound size={18} strokeWidth={2} />
              </InputGroup.Text>
              <Form.Control
                className='login-input border-0 bg-transparent shadow-none px-0'
                placeholder="Enter your username"
                aria-label="Phone"
                aria-describedby="phone"
                name='phone'
                value={values.phone || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={showOtp}
                style={{ fontSize: '14px', height: '45px' }}
              />
            </InputGroup>
            {errors.phone && touched.phone ? (<div className='text-danger mt-1 ms-1' style={{ fontSize: '12px' }}>{errors.phone}</div>) : null}
          </div>

          <div className='mb-1'>
            <Form.Label className='fw-semibold mb-1 text-dark' style={{ fontSize: '13px' }}>Password</Form.Label>
            <InputGroup
              className="rounded-3 shadow-sm"
              style={{ border: '1px solid #e1e5eb', overflow: 'hidden', backgroundColor: '#f9fafb' }}
            >
              <InputGroup.Text id="password" className="bg-transparent border-0 text-muted px-3">
                <KeyRound size={18} strokeWidth={2} />
              </InputGroup.Text>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                className='login-input border-0 bg-transparent shadow-none px-0'
                placeholder="Enter your password"
                aria-label="Password"
                aria-describedby="password"
                name='password'
                value={values.password || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={showOtp}
                style={{ fontSize: '14px', height: '45px' }}
              />
              <InputGroup.Text
                id="password"
                onClick={() => setShowPassword(!showPassword)}
                className="bg-transparent border-0 text-muted px-3"
                style={{ cursor: 'pointer' }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </InputGroup.Text>
            </InputGroup>
            {errors.password && touched.password ? (<div className='text-danger mt-1 ms-1' style={{ fontSize: '12px' }}>{errors.password}</div>) : null}
          </div>

          {showOtp && (
            <div className='mt-2'>
              <div className="text-center px-4 py-2 bg-light rounded-4 border border-light">
                <Form.Label className='fw-bold mb-2' style={{ color: '#001529', fontSize: '14px' }}>Enter 6-Digit OTP</Form.Label>
                <p className="text-muted small mb-3">Please check your registered email or phone.</p>
                <Input.OTP size='large' length={6} value={otp} onChange={(value) => setOtp(value)} />
              </div>
            </div>
          )}

          <div className="mt-2 text-center">
            {!showOtp ? (
              <Button type='submit' className='w-100 login_save_btn shadow text-uppercase fw-bold rounded-3' style={{ letterSpacing: '1px' }} disabled={spinner}>
                {spinner ? <ButtonLoader /> : 'Sign In'}
              </Button>
            ) : (
              <Button type='button' className='w-100 login_save_btn shadow text-uppercase fw-bold rounded-3' style={{ letterSpacing: '1px' }} disabled={spinner || otp.length < 6} onClick={handleVerifyOtp}>
                {spinner ? <ButtonLoader /> : 'Verify OTP'}
              </Button>
            )}
          </div>
        </Card.Body>

        <Card.Footer className="bg-light border-top-0 px-4 py-2 text-center">
          <span style={{ fontSize: '12px' }} className='text-muted'>
            By continuing, you agree to the <br />
            <u className='fw-medium text-dark' style={{ cursor: 'pointer', textDecorationColor: '#006972' }}>Terms of Service</u> and <u className='fw-medium text-dark' style={{ cursor: 'pointer', textDecorationColor: '#006972' }}>Privacy Policy</u>
          </span>
        </Card.Footer>

      </Form>
    </Card>
  )
}